import React from 'react';
import { Box, Divider, Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, Button } from '@mui/material';
import { formatDateHour2 } from '../utils/lib';
import InventoryIcon from '@mui/icons-material/Inventory';
import ClinicHeaderItem from './ClinicHeaderItem';
import ListItemWAvatar from './ListItemWAvatar';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { useSnackbar } from '../providers/SnackBarProvider';
import { handleError } from '../utils/lib';
import { useTranslation } from 'react-i18next';

function SupplyItem({supply, onDelete, canEdit, config}) {
  const navigate = useNavigate();
  const snackbar = useSnackbar();
  const { t } = useTranslation();
  const [openConfirm, setOpenConfirm] = React.useState(false);
  const isSupplied = supply.date_supply ? true : false;

  const handleDelete = async () => {
    try {
      await axios.delete(
        `${import.meta.env.VITE_API_URL}pets_supply?id=${supply.id}`,
        { withCredentials: true }
      );
      if (onDelete) {
        onDelete(supply.id);
      }
    } catch (error) {
      handleError(error, snackbar);
    }
    setOpenConfirm(false);
  };

  const handleOpenConfirm = () => {
    setOpenConfirm(true);
  };

  const handleCloseConfirm = () => {
    setOpenConfirm(false);
  };

  const getTitle = () => {
    if (config?.vet?.id === supply.vet.id) {
      return supply.user.name;
    }
    return `${supply.user.name} | ${supply.vet.name}`;
  };
  
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        mb: 2,
      }}
    >
      {/* Encabezado usando ClinicHeaderItem */}
      <ClinicHeaderItem 
        title={getTitle()}
        subtitle={formatDateHour2(supply.date_supply, config)}
        age={supply.age}
        thumbUrl={supply.user.thumb_url}
        onDelete={canEdit ? handleOpenConfirm : undefined}
      />

      <Box sx={{ mt: 2 }}>
        <ListItemWAvatar
          primary={supply.product?.name}
          thumbUrl={supply.product?.thumb_url}
          size="small"
          defaultIcon={<InventoryIcon sx={{ fontSize: '16px' }} />}
        />
      </Box>

      {/* Línea divisoria */}
      <Divider
        sx={{
          marginTop: 1,
          marginBottom: 1,
          backgroundColor: '#dadada',
          height: 1,
        }}
      />

      <Dialog
        open={openConfirm}
        onClose={handleCloseConfirm}
      >
        <DialogTitle>{t('common.confirmDeletion')}</DialogTitle>
        <DialogContent>
          <DialogContentText>
            {t('layouts.confirmDeleteSupply')}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseConfirm} color="primary">
            {t('common.cancel')}
          </Button>
          <Button onClick={handleDelete} color="error" autoFocus>
            {t('common.delete')}
          </Button>
        </DialogActions>
      </Dialog>
    </Box>  
  );
}

export default SupplyItem; 